document.addEventListener('DOMContentLoaded', () => {
    let searchBars = document.querySelectorAll('.search-trigger');
    let resultsWrapper = document.querySelector('.predictive-search-container')
    let resultsContainer = resultsWrapper.querySelector('.inner');

    searchBars.forEach(searchBar => {

        // Site search using predictive search api
        const predictiveSearchCallBack = () => {
            const section_name = 'bt-predictive-search';

            if (searchBar.value.length > 2) {

                var requestResponse;
                fetch(`/search/suggest?q=${searchBar.value}&resources[type]=product,collection,article,page&section_id=${section_name}`)
                    .then((response) => {
                        requestResponse = response;
                        return response.text();
                    })
                    .then((text) => {
                        if (!requestResponse.ok) {
                            throw new Error(`${requestResponse.status}: ${text}`);
                        }
                        resultsWrapper.classList.add('active');

                        const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
                        const sectionHTML = parsedHTML.querySelector(`#shopify-section-${section_name}`);

                        if (!sectionHTML) return;

                        if(document.querySelector('div[data-trade-customer]').getAttribute('data-trade-customer') == "false") {
                            const productItems = sectionHTML.querySelectorAll('.product-card-link');

                            // Filter out products looking at the trade badge (make sure we keep the badge or will need another check)
                            productItems.forEach(item => {
                                const tradeBadge = item.querySelectorAll('.product-badge.trade-badge');

                                if(tradeBadge.length > 0) {
                                    item.remove();
                                }
                            });
                        }
                        
                        resultsContainer.innerHTML = sectionHTML.innerHTML;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            } else {
                //resultsContainer.innerHTML = '';
                //resultsWrapper.classList.remove('active');
            }
        }

        let searchMethod = predictiveSearchCallBack;

        if (searchBar && resultsContainer) {
            searchBar.addEventListener('keyup', searchMethod)
        }
    })

})